import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {
  AppTableComponent,
  Auth,
  MessagesComponent,
  ModalWindowComponent, OpnIntroductionModel, RequestItemsListViewModel, RequestItemsListViewService, RequestsService,
  SearchModel,
  SearchUtil,
  SupplierOfferItemModel,
  SupplierOfferItemService,
  SupplierOfferModel,
  SupplierOfferService,
  ViewState
} from 'src/common';
import {TranslationManager} from 'src/common/translation';
import {Router} from '@angular/router';
import {RequestItemSelectComponent} from "../../components/request-item-select";
import {SupplierOfferItemDetailComponent} from "../supplier-offer-item-detail";
import { LocaleService } from 'src/common/services/locale';


@Component({
  selector: 'app-supplier-offer-item-ssy1240list',
  templateUrl: './supplier-offer-item-ssy1240list.component.html'
})


export class SupplierOfferItemSsy1240listComponent implements AfterViewInit, OnInit {

  // custom-constructor-start
  constructor(private router: Router, private supplierOfferItemService: SupplierOfferItemService, private supplierOfferService: SupplierOfferService,
              private requestsService: RequestsService, private requestItemListService: RequestItemsListViewService) {
  }

  private _state: ViewState;
  private _supplierOfferId: number;
  private _requestRoundId: number;

  @Input('procurementModelUniqueIdentifier') procurementModelUniqueIdentifier: string;
  @Input('isAuctionStarted') isAuctionStarted: boolean;

  supplierOfferItem: SupplierOfferItemModel;

  originalItems: SupplierOfferItemModel[];
  // @ViewChild("requestItemSelect") requestItemSelect: RequestItemSelectComponent;

  @ViewChild("supplierOfferItemDetail") supplierOfferItemDetail: SupplierOfferItemDetailComponent;

  @Output() newSupplierOfferEvent = new EventEmitter<number>();

  // custom-constructor-end

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("modalWindow") modalWindow: ModalWindowComponent;

  translationManager = TranslationManager;
  localeService = LocaleService;

  items: SupplierOfferItemModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;
  customHeaderText = '';
  @Input()
  requestId: number;

  @Input() stateDetail: ViewState;
  viewState = ViewState;

  ngOnInit(): void {
    //this.initForm();

  }


  ngAfterViewInit(): void {
    this.appTable.onSearch = this.doSearch.bind(this);
    this.appTable.search();
  }

  doSearch(search: SearchModel) {

    if (!this.originalItems) {
      this.supplierOfferItemService.supplierOfferItems(this._supplierOfferId).then((result: any) => {
        this.originalItems = result;
        let res = SearchUtil.searchList(this.originalItems.map(a => {
          return {...a}
        }), search);
        this.items = res;
        let count = res.length;
        this.appTable.setTotalCount(count);

      })
    } else {
      let res = SearchUtil.searchList(this.originalItems.map(a => {
        return {...a}
      }), search);
      this.items = res;
      let count = res.length;
      this.appTable.setTotalCount(count);
    }
  }

  create() {
    this.routerNavigateToCreate();
  }


  openDetails(id: number) {
    this.router.navigate(['/supplierOfferItems/details/' + id]);
  }

  delete() {
    this.showDeleteModal = false;
    this.supplierOfferItemService.delete(this.idForDelete).then(() => {
      this.supplierOfferItemService.getAll().then((items: SupplierOfferItemModel[]) => {
        this.items = items;
      });
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
    });
  }


  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  // custom-start
  private routerNavigateToCreate() {
    this.router.navigate(['supplier-offer-item/create']);
  }

  get supplierOfferId(): number {
    return this._supplierOfferId;
  }

  @Input()
  set supplierOfferId(value: number) {
    this._supplierOfferId = value;
  }

  get requestRoundId(): number {
    return this._requestRoundId;
  }

  @Input()
  set requestRoundId(value: number) {
    this._requestRoundId = value;

  }

  itemDetails(item) {
    this.stateDetail = ViewState.Details;
    this.supplierOfferItem = item;

    if(this.supplierOfferItem.creatingWayId == 2) {
      this.supplierOfferItemService.supplierOfferItemParams(this.supplierOfferItem.id).then(
        res => {
          let params = res;
          this.supplierOfferItem['params'] = params;
          this.supplierOfferItemDetail.showModal(undefined, this.supplierOfferItem).then((data1: any) => {

          });
        }
      ).catch(err => {
        console.log(err);
      });
    } else {
      this.supplierOfferItemService.supplierOfferItemDescriptions(this.supplierOfferItem.id).then(
        res => {
          if(res && res.length > 0) {
            let a1 = res[0];
            this.supplierOfferItem['requestDescription'] = a1['requestDescription'];
            this.supplierOfferItem['description'] = a1['description'];
          }

          this.supplierOfferItemDetail.showModal(undefined, this.supplierOfferItem).then((data1: any) => {

          });
        }
      ).catch(err => {
        console.log(err);
      });
    }
  }

  itemCreate() {

  }

  itemEdit(item) {
    this.stateDetail = ViewState.Edit;
    this.supplierOfferItem = item;

    if(this.supplierOfferItem.creatingWayId == 2) {
      this.supplierOfferItemService.supplierOfferItemParams(this.supplierOfferItem.id).then(
        res => {
          let params = res;
          this.supplierOfferItem['params'] = params;
          this.supplierOfferItemDetail.showModal(undefined, this.supplierOfferItem).then((data1: any) => {
            if (data1) {
              let item = data1['itemValue'];
              item['Parameters'] = data1['paramValues'];

              if (this._supplierOfferId) {
                item.SupplierOfferId = +this._supplierOfferId;

                if (item['Parameters']) {
                  item['Parameters'] = item['Parameters'].map(a1 => {
                    a1['SupplierOfferItemVersionId'] = item.ItemVersionId;
                    a1['SupplierOfferId'] = item.SupplierOfferId;
                    a1['SupplierOfferItemId'] = item.Id;
                    return a1;
                  });
                }
                this.supplierOfferItemService.save(item).then(
                  res => {
                    MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
                    this.originalItems = undefined;
                    this.appTable.onSearch = this.doSearch.bind(this);
                    this.appTable.search();
                  }
                ).catch(err => {
                  console.log(err);
                });

              }
            }
          });
        }
      ).catch(err => {
        console.log(err);
      });
    }
    else {
      this.supplierOfferItemService.supplierOfferItemDescriptions(this.supplierOfferItem.id).then(
        res => {
          if(res && res.length > 0) {
            let a1 = res[0];
            this.supplierOfferItem['requestDescription'] = a1['requestDescription'];
            this.supplierOfferItem['description'] = a1['description'];
          }

          this.supplierOfferItemDetail.showModal(undefined, this.supplierOfferItem).then((data1: any) => {
            if (data1) {
              let item = data1['itemValue'];
              item['Parameters'] = data1['paramValues'];

              if (this._supplierOfferId) {
                item.SupplierOfferId = +this._supplierOfferId;

                if (item['Parameters']) {
                  item['Parameters'] = item['Parameters'].map(a1 => {
                    a1['SupplierOfferItemVersionId'] = item.ItemVersionId;
                    a1['SupplierOfferId'] = item.SupplierOfferId;
                    a1['SupplierOfferItemId'] = item.Id;
                    return a1;
                  });
                }
                this.supplierOfferItemService.save(item).then(
                  res => {
                    MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
                    this.originalItems = undefined;
                    this.appTable.onSearch = this.doSearch.bind(this);
                    this.appTable.search();
                  }
                ).catch(err => {
                  console.log(err);
                });

              }
            }
          });
        }
      ).catch(err => {
        console.log(err);
      });
    }

  }

  itemCopy(item) {
    this.stateDetail = ViewState.Edit;
    this.supplierOfferItem = item;
    if(this.supplierOfferItem.creatingWayId == 2) {
      this.supplierOfferItemService.supplierOfferItemParams(this.supplierOfferItem.id).then(
        res => {
          let params = res;
          this.supplierOfferItem['params'] = params;

          this.supplierOfferItemDetail.showModal(undefined, this.supplierOfferItem).then((data1: any) => {
            if(!data1){
              return ;

            }
            let item = data1['itemValue'];
            item['Parameters'] = data1['paramValues'];

            if (this._supplierOfferId) {
              item.SupplierOfferId = +this._supplierOfferId;
              if (item.ItemVersionId) {
                item.ItemVersionId = +item.ItemVersionId + 1;
              } else {
                item.ItemVersionId = 1;
              }
              item['Id'] = undefined;
              item['Parameters'] = item['Parameters'].map(a1 => {
                a1['SupplierOfferItemVersionId'] = item.ItemVersionId;
                a1['SupplierOfferId'] = item.SupplierOfferId;
                a1['ElementId'] = undefined;
                a1['Id'] = undefined;
                return a1;
              });
              this.supplierOfferItemService.save(item).then(
                res => {
                  this.originalItems = undefined;
                  this.appTable.onSearch = this.doSearch.bind(this);
                  this.appTable.search();
                }
              ).catch(err => {
                console.log(err);
              });

            }
          });
        }
      ).catch(err => {
        console.log(err);
      });
    } else {
      this.supplierOfferItemService.supplierOfferItemDescriptions(this.supplierOfferItem.id).then(
        res => {
          if(res && res.length > 0) {
            let a1 = res[0];
            this.supplierOfferItem['requestDescription'] = a1['requestDescription'];
            this.supplierOfferItem['description'] = a1['description'];
          }

          this.supplierOfferItemDetail.showModal(undefined, this.supplierOfferItem).then((data1: any) => {
            if (data1) {
              let item = data1['itemValue'];
              item['Parameters'] = data1['paramValues'];

              if (this._supplierOfferId) {
                item.SupplierOfferId = +this._supplierOfferId;
                if (item.ItemVersionId) {
                  item.ItemVersionId = +item.ItemVersionId + 1;
                } else {
                  item.ItemVersionId = 1;
                }
                item['Id'] = undefined;

                this.supplierOfferItemService.save(item).then(
                  res => {
                    MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
                    this.originalItems = undefined;
                    // this.items = undefined;
                    this.appTable.onSearch = this.doSearch.bind(this);
                    this.appTable.search();
                  }
                ).catch(err => {
                  console.log(err);
                });

              }
            }
          });
        }
      ).catch(err => {
        console.log(err);
      });
    }
  }

  itemDelete(id: number) {
    this.supplierOfferItemService.delete(id).then(
      res1 => {
        this.originalItems = undefined;
        this.appTable.onSearch = this.doSearch.bind(this);
        this.appTable.search();
      }).catch(
      reason => {
        MessagesComponent.instance.showError([reason.error.messages]);
      }
    );
  }

  groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };


  get state(): ViewState {
    return this._state;
  }

  @Input()
  set state(value: ViewState) {
    this._state = value;
  }

  isDisabledByProcurementModel() {
    if (
      this.procurementModelUniqueIdentifier === 'AuctionOpen' ||
      this.procurementModelUniqueIdentifier === 'AuctionSemiOpen' ||
      this.procurementModelUniqueIdentifier === 'AuctionClosed'
    ) {
      return true;
    } else {
      return false;
    }
  }

}

